
const environment = {
    API_URL: "https://ivec2027.org.in/api/",
};


export default environment;
